import React from 'react'
import Img from 'gatsby-image'
import Dish from '../components/dish'
import { Sticky } from 'react-sticky'

export default ({groupedDishes,menuCategory}) => {
  return (
	  <div key={'cat'+menuCategory.node.id}>
	    <Sticky relative={true} topOffset={70}>
	      {({ style,isSticky }) => (
	        <div className={(isSticky?'fixed':'') + ' dish-category'} style={style}>
	          {menuCategory.node.backgroundImage && (
	            <Img className="dish-category-image" fluid={menuCategory.node.backgroundImage.fluid}  />
	          )}
	          <div className="dish-category-content">
	            <div className="dish-category-content-inner">
	              <h3 className="dish-category-title">{menuCategory.node.name}</h3>
	            </div>
	          </div>
	        </div>
	      )}
	    </Sticky>
	    <div className="dishes tight">
	      {groupedDishes[menuCategory.node.id] && groupedDishes[menuCategory.node.id].map(dish => (
	        <Dish
	          key={'c-'+menuCategory.node.id+'-dish-'+dish.id}
	          number={dish.number}
	          title={dish.title}
	          imgData={dish.image ? dish.image.fluid : null}
	          prices={dish.prices || menuCategory.node.defaultPrices}
	          spiciness={dish.spiciness || null}
	          description={dish.description} />
	      ))}
	    </div>
	  </div>
  );
}
